// Cellery Soapbox — Firebase Web SDK initialization (contract).
// Reads config from Vite env (VITE_FIREBASE_*). Google sign-in is hinted to the
// cellery.ai Workspace domain via `hd`; the real enforcement is server-side
// (session function, contentProxy) and in firestore.rules.

import { initializeApp } from "firebase/app";
import {
  GoogleAuthProvider,
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { ALLOWED_DOMAIN } from "./types";

const databaseURL = import.meta.env.VITE_FIREBASE_DATABASE_URL;

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  databaseURL,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
void setPersistence(auth, browserLocalPersistence);
export const db = getFirestore(app);

// Realtime Database — used only for ephemeral presence (who's online + mode).
// Null-guarded so the app still runs if RTDB is unconfigured (presence no-ops).
export const rtdb = databaseURL ? getDatabase(app) : null;

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ hd: ALLOWED_DOMAIN });
